module.exports = __webpack_public_path__ + "img/logo_solar_cyber_ru.7dd52583.svg";